import React from 'react'
import { Link } from 'react-router-dom'
import { C, fOutfit, fBody, fMono, PublicNav, PublicFooter } from '../../../Shared/Brand'

const SPREAD_ROWS = [
  { market: 'Forex Pairs', std: 'From 1.0 pips', ecn: 'From 0.0 pips + $3.5/lot', pro: 'From 0.0 pips' },
  { market: 'Precious Metals', std: 'From 0.30', ecn: 'From 0.05 + $3.5/lot', pro: 'From 0.02' },
  { market: 'Energies', std: 'From 0.04', ecn: 'From 0.02 + $3.5/lot', pro: 'From 0.01' },
  { market: 'Indices', std: 'From 0.6 pts', ecn: 'From 0.3 pts + $3.5/lot', pro: 'From 0.2 pts' },
  { market: 'Cryptocurrencies', std: 'From 18 USD', ecn: 'From 10 USD + $3.5/lot', pro: 'From 6 USD' },
]

const OTHER_FEES = [
  { label: 'Deposit Fee', value: 'None' },
  { label: 'Withdrawal Fee', value: 'Network fee only, no additional charge' },
  { label: 'Inactivity Fee', value: 'None' },
  { label: 'Overnight Swap', value: 'Applies on positions held past end of trading day — swap-free available on request' },
]

export default function Pricing() {
  return (
    <div style={{ background: C.white, color: C.tx, fontFamily: fBody, minHeight: '100vh' }}>
      <style>{`
        .xpr-wrap { overflow-x: auto; border: 1px solid ${C.bdr}; border-radius: 12px; margin-bottom: 32px; }
        .xpr-table { width: 100%; border-collapse: collapse; font-size: 13px; min-width: 560px; }
        .xpr-table th, .xpr-table td { padding: 12px 16px; border-bottom: 1px solid ${C.bdr}; text-align: left; }
        .xpr-table th { color: ${C.tx}; font-family: ${fOutfit}; font-weight: 700; }
        .xpr-table td { color: ${C.tx2}; }
        .xpr-fees-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 14px; }
      `}</style>
      <PublicNav active="Trading" />

      <section style={{ padding: '130px 24px 50px', textAlign: 'center', borderBottom: `1px solid ${C.bdr}` }}>
        <div style={{ fontSize: '11px', fontFamily: fMono, letterSpacing: '0.14em', color: C.primary, textTransform: 'uppercase', marginBottom: '10px' }}>Trading Conditions</div>
        <h1 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(32px,5vw,48px)', lineHeight: 1.1, margin: '0 0 12px', color: C.tx }}>Transparent Pricing</h1>
        <p style={{ fontSize: '16px', fontWeight: 500, color: C.tx2, maxWidth: '560px', margin: '0 auto' }}>Compare indicative spreads across markets and account types — no hidden fees.</p>
      </section>

      <section style={{ padding: '60px 24px', maxWidth: '900px', margin: '0 auto' }}>
        <h2 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(26px,3.5vw,34px)', lineHeight: 1.1, textAlign: 'center', margin: '0 0 24px', color: C.tx }}>Indicative Spreads By Market</h2>
        <div className="xpr-wrap">
          <table className="xpr-table">
            <thead><tr><th>Market</th><th>STD</th><th>ECN</th><th>PRO</th></tr></thead>
            <tbody>
              {SPREAD_ROWS.map(r => <tr key={r.market}><td>{r.market}</td><td>{r.std}</td><td>{r.ecn}</td><td>{r.pro}</td></tr>)}
            </tbody>
          </table>
        </div>

        <h2 style={{ fontFamily: fOutfit, fontWeight: 700, fontSize: 'clamp(26px,3.5vw,34px)', lineHeight: 1.1, textAlign: 'center', margin: '0 0 20px', color: C.tx }}>Other Fees</h2>
        <div className="xpr-fees-grid">
          {OTHER_FEES.map(f => (
            <div key={f.label} style={{ background: C.light, border: `1px solid ${C.bdr}`, borderRadius: '12px', padding: '16px' }}>
              <div style={{ fontSize: '12px', color: C.tx3, marginBottom: '6px' }}>{f.label}</div>
              <div style={{ fontSize: '13px', color: C.tx, fontWeight: 600 }}>{f.value}</div>
            </div>
          ))}
        </div>

        <p style={{ fontSize: '11px', color: C.tx3, marginTop: '24px', textAlign: 'center' }}>
          Spreads shown are indicative and vary with market conditions, liquidity, and volatility. See <Link to="/trading/account-comparison" style={{ color: C.tx2, textDecoration: 'underline' }}>Account Comparison</Link> for full account specifications.
        </p>

        <div style={{ textAlign: 'center', marginTop: '28px' }}>
          <Link to="/signup" style={{ display: 'inline-block', background: C.primary, color: C.dark, fontWeight: 700, fontSize: '13px', padding: '11px 28px', borderRadius: '999px', textDecoration: 'none' }}>Sign Up</Link>
        </div>
      </section>

      <PublicFooter />
    </div>
  )
}
